import React from "react";
import {
  SatisfactionIcon1,
  SatisfactionIcon2,
  SatisfactionIcon3,
  SatisfactionIcon4,
  SatisfactionIcon5
} from "../components/icons/icons";

export const satisfactionTexts = [
  "Inaccurate results",
  "User interface problem",
  "Wrong HS code description",
  "The application is slow",
  "Missing or incorrect HS code",
  "Other"
];

export const satisfactionStatuses = [
  {
    id: "5",
    iconGenerator: (isActive: boolean) => <SatisfactionIcon1 isActive={isActive} />
  },
  {
    id: "4",
    iconGenerator: (isActive: boolean) => <SatisfactionIcon2 isActive={isActive} />
  },
  {
    id: "3",
    iconGenerator: (isActive: boolean) => <SatisfactionIcon3 isActive={isActive} />
  },
  {
    id: "2",
    iconGenerator: (isActive: boolean) => <SatisfactionIcon4 isActive={isActive} />
  },
  {
    id: "1",
    iconGenerator: (isActive: boolean) => <SatisfactionIcon5 isActive={isActive} />
  }
];

export const LAST_FEEDBACK_DATE_STORAGE_KEY = "LAST_FEEDBACK_DATE";
// 14 days in milliseconds
export const FEEDBACK_DISABLE_PERIOD = 12096e5;
